import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import { LEAD_TYPES_OPTIONS_FOR_QUOTE_FUNNEL, default_hours_of_operation, default_products_offered, footerLinksatQuoteFunnel } from 'helpers/sf_constants';
import { getAnswerAgentProfile, getQuoteFunnelQuestions } from 'store/quote_funnels/answers/actions';
import { useParams } from 'react-router-dom';
import { MetaTags } from 'react-meta-tags';
import Header from './QuoteFunnelAnswerLayout/Header';
import useQuoteFunnelOrderedQuestions from 'hooks/useQuoteFunnelOrderedQuestions';
import { addPadStart, safeJSONParse } from 'helpers/sf_utils';
import runded_phone_icon from "assets/images/rounded-circle-phone.svg"
import useQuery from 'hooks/useQuery';
import { formatPhoneNumber } from 'helpers/quote_funnel_helper';
import CallNowPopupModal from './CallNowPopupModal';
import { getAgentProfilePopupMessage } from 'store/quote_funnels/actions';
// import image_url from "../../assets/images/users/avatar-9.jpg"

const variable_mappings = [
    { 'vehicle_year': 'vehicles_year_1' },
    { 'vehicle_make': 'vehicles_make_1' },
    { 'vehicle_model': 'vehicles_model_1' },
    { 'first_name': 'first_name' },
    { 'last_name': 'last_name' }
];

const ThankYouQuoteFunnelAnswer = () => {

    const dispatch = useDispatch();

    const { campaign_id, session_id } = useParams()
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const updateIsMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };
        window.addEventListener('resize', updateIsMobile);
        return () => {
            window.removeEventListener('resize', updateIsMobile);
        };
    }, []);

    const initial_params = {
        session_id: session_id,
        campaign_id: campaign_id
    }

    useEffect(() => {
        dispatch(getAnswerAgentProfile(initial_params));
        dispatch(getQuoteFunnelQuestions(initial_params));
    }, [dispatch]);
    const query = useQuery();
    const preview = parseInt(query.get('preview') || 0);
    const {
        answer_agent_profile,
        answer_agent_profile_loading,
        quote_funnel_questions,
        quote_funnel_questions_loading,
    } = useSelector((state) => ({
        answer_agent_profile: state.QuoteFunnelAnswersAgentProfileReducer.answer_agent_profile,
        answer_agent_profile_loading: state.QuoteFunnelAnswersAgentProfileReducer.answer_agent_profile_loading,
        quote_funnel_questions: state.QuoteFunnelAnswersAgentProfileReducer.quote_funnel_questions,
        quote_funnel_questions_loading: state.QuoteFunnelAnswersAgentProfileReducer.quote_funnel_questions_loading,
    }));
    const productsOffered = safeJSONParse(answer_agent_profile?.products_offered, default_products_offered);
    const [quote_funnel_questions_ordered] = useQuoteFunnelOrderedQuestions();

    useEffect(() => {
        answer_agent_profile?.id && dispatch(getAgentProfilePopupMessage(answer_agent_profile?.id))
    }, [answer_agent_profile])


    let first_name = quote_funnel_questions_ordered.find(item => item.field_name === 'first_name')?.value;
    // Since questions are ordered, pick the first one which matches (if exact match fails)
    if (!first_name) {
        first_name = quote_funnel_questions_ordered.find(item => item.field_name.includes('first_name'))?.value;
    }

    let address = `${answer_agent_profile?.name} ${answer_agent_profile?.address} ${answer_agent_profile?.city} ${answer_agent_profile?.zip_code}`

    const renderedProducts = productsOffered?.map((productValue) => {
        const product = LEAD_TYPES_OPTIONS_FOR_QUOTE_FUNNEL.find((item) => item.value.toString() === productValue.lead_type_id.toString() && productValue.is_active);
        return product ? product.label : null;
    });
    let page_title = !answer_agent_profile?.name ? '' : (answer_agent_profile?.name + " | " + quote_funnel_questions?.name)

    // Sections start
    const AGENT_PROFILE_SECTION = <>
        <section id='qtf-ty-profile-info'>
            <div className="d-flex align-items-center">
                <div className='quote-funnel-answer-footer-img'>
                    {!answer_agent_profile_loading && answer_agent_profile?.profile_img_url &&
                        <img src={answer_agent_profile?.profile_img_url} alt="Profile Image" className="quote-funnel-answer-thankyou-page-footer-user-log me-3" />
                    }
                </div>
                <div className='w-100'>
                    <div className='quote-funnel-answer-footer-span-container-profile'>
                        <span className='quote-funnel-thank-you-page-company-name'>{answer_agent_profile?.name}</span>
                        <span className='quote-funnel-thank-you-page-company-info mb-0 pb-0'>{answer_agent_profile?.carrier}</span>
                        <span className='quote-funnel-thank-you-page-company-info mb-0 pb-0'>{answer_agent_profile?.address}, {answer_agent_profile?.city}, {answer_agent_profile?.state} {addPadStart(answer_agent_profile?.zip_code)}</span>
                        <span className='quote-funnel-thank-you-page-company-info fw-bold' style={{ color: '#3486e5' }}>{formatPhoneNumber(quote_funnel_questions?.tracking_number)}</span>
                    </div>
                </div>
            </div>
        </section>
    </>

    const MAP_SECTION = <>
        <section id="qtf-ty-map">
            <div className='w-100'>
                <iframe
                    title="Google Map"
                    className="quote-funnel-answer-footer-border"
                    src={`https://maps.google.com/maps?width=500&height=400&hl=en&q=${encodeURIComponent(address)}&t=&z=14&ie=UTF8&iwloc=B&output=embed`}
                ></iframe>
            </div>
        </section>
    </>

    const ABOUT_US_SECTION = <>
        {answer_agent_profile?.agency_info && <section id="qtf-ty-about-us">
            <div className="products mb-3">
                <h4 className='fs-18 fw-bold'>About Us</h4>
                {answer_agent_profile?.agency_info && (
                    <div className='fs-18 agency-info-thank-you-page'>
                        {answer_agent_profile?.agency_info?.split('\n')?.map((paragraph, index) => (
                            <p key={index}>{paragraph}</p>
                        ))}
                    </div>
                )}
            </div>
        </section>}
    </>

    const PRODUCTS_OFFERED_SECTION = <>
        {renderedProducts && renderedProducts.some(product => product !== null) && (
            <section id="qtf-ty-products">
                <h4 className='fs-18 fw-bold'>Products Offered</h4>
                <ul className="row" style={{ margin: 0, padding: 0 }}>
                    {renderedProducts.map((product, index) => product && (
                        <li className='col-md-6 col-sm-6 fs-16' style={{ listStyleType: "none", marginBottom: "2px", padding: 0 }} key={index}>
                            <span className="d-flex fs-18 align-items-top">
                                <i className="bx bx-check pt-1 fw-bold me-1 fs-18" aria-hidden="true" style={{ color: '#3486e5' }}></i>
                                {product}
                            </span>
                        </li>
                    ))}
                </ul>
            </section>
        )}
    </>

    const HOURS_OF_OPERATION_SECTION = <>
        <section id="qtf-ty-hours-of-operation">
            <h4 className='fs-18 fw-bold'>Hours of Operation</h4>
            {(safeJSONParse(answer_agent_profile?.hours_of_operation, default_hours_of_operation))?.map((operation, index) => (
                <span className='d-flex fs-18'>
                    <span className='text-capitalize' style={{ minWidth: '100px' }}>{operation?.day || ""}</span>
                    <span className='ms-3'>{operation?.is_active ? (`${operation?.from || ""} - ${operation?.to || ""}`) : "Closed"}</span>
                </span>
            ))}
        </section>
    </>

    const LANGUAGES_SECTION = <>
        {answer_agent_profile?.languages && answer_agent_profile.languages.length > 0 && (
            <section id="qtf-ty-languages-spoken">
                <h4 className='fs-18 fw-bold'>Languages Spoken</h4>
                {answer_agent_profile.languages.map((language, index) => (
                    <ul key={index} style={{ margin: 0, padding: 0 }}>
                        <li className='d-flex fs-18 align-items-center' style={{ listStyleType: "none", marginBottom: "8px", padding: 0, lineHeight: '1.2' }}>
                            {language}
                        </li>
                    </ul>
                ))}
            </section>
        )}
    </>

    // Sections end

    return (
        <div className='quote-funnel-div-wrapper'>
            <div className="page-content quote-funnel-div" style={{ padding: '0px' }}>
                <React.Fragment>
                    <MetaTags>
                        <title>{page_title}</title>
                    </MetaTags>

                    {!answer_agent_profile_loading && <Header answer_agent_profile={answer_agent_profile}
                        lead_type_id={null}
                        user_name={null}
                        tracking_number={quote_funnel_questions?.tracking_number}
                        phone_number_text={preview === 1 ? answer_agent_profile?.phone_num : null}
                    />}
                    <Container className='my-5'>
                        <CallNowPopupModal
                            lead_type_id={quote_funnel_questions?.lead_type_id}
                            variable_mappings={variable_mappings}
                        />
                        <Row className='text-center mb-3'>
                            <Col md="12">
                                <h1 className="text-bold text-black quote-funnel-answer-header quote-funnel-unique-h1">Last Step<span className='text-capitalize'>{(!!first_name && `, ${first_name}`)}</span>.</h1>
                                <p className='quote-funnel-agent-details-info mx-2'>
                                    Call {answer_agent_profile?.name} now to get your quote.

                                </p>

                                <a className="text-white btn quote-funnel-continue-and-quote-btn btn-lg quote-funnel-answer-btn mb-2" href={`tel:${quote_funnel_questions?.tracking_number || ''}`}>
                                    <span className='d-flex justify-content-center qf-call-now-btn-small-screen align-items-center'>
                                        <img src={runded_phone_icon} className='me-2' />Call Now: {formatPhoneNumber(quote_funnel_questions?.tracking_number)}
                                    </span>
                                </a>
                            </Col>
                            <div className="d-flex justify-content-center align-item-center">
                                <i className='mdi mdi-circle font-size-16 mt-1' style={{ color: "#36b04b" }} />
                                <span className="ms-2" style={{ marginTop: '6px' }}>Your quote is ready & agents are available</span>
                            </div>
                        </Row>
                    </Container>
                    <div className='quote-funnel-answer-footer p-3'>
                        <Container className='mt-4'>
                            {isMobile ? (
                                <>
                                    <Row>
                                        <Col lg={6}>
                                            {AGENT_PROFILE_SECTION}
                                        </Col>
                                        <Col lg={6}>
                                            {MAP_SECTION}
                                        </Col>
                                        <Col lg={6}>
                                            {ABOUT_US_SECTION}
                                        </Col>
                                        <Col lg={6}>
                                            {PRODUCTS_OFFERED_SECTION}
                                        </Col>
                                        <Col lg={6}>
                                            {HOURS_OF_OPERATION_SECTION}
                                        </Col>
                                        <Col lg={6}>
                                            {LANGUAGES_SECTION}
                                        </Col>
                                    </Row>
                                </>
                            ) : (
                                <Row>
                                    <Col md={7}>
                                        {AGENT_PROFILE_SECTION}
                                        {ABOUT_US_SECTION}
                                        {HOURS_OF_OPERATION_SECTION}

                                    </Col>
                                    <Col md={5}>
                                        {MAP_SECTION}
                                        {PRODUCTS_OFFERED_SECTION}
                                        {LANGUAGES_SECTION}
                                    </Col>
                                </Row>
                            )
                            }
                            <div className={`quote-funnel-answer-footer-span-container my-4`}>
                                <span className='fs-16'>
                                    Powered by Goal
                                </span>
                                <span>
                                    <div className='footer-links mt-2'>
                                        {footerLinksatQuoteFunnel.map((link, index) => (
                                            <span key={index} className='me-2 mb-2' style={{ color: '#3486e5' }}>
                                                {link.link} {!(index == footerLinksatQuoteFunnel.length - 1) && <span className='footer-links-line ms-2'>|</span>}
                                            </span>
                                        ))}
                                    </div>
                                    <span className='small d-flex justify-content-center'>As part of our ongoing effort to provide you with the best possible service, Goal Platform LLC and its Service Providers may monitor and/or record and retain all activity on this website and its applicable links, through the use of cookies, tracking pixels or other methods, for informational and quality control purposes.</span>
                                </span>
                            </div>
                        </Container>
                    </div>
                </React.Fragment>
            </div>
        </div>
    )
};

export default ThankYouQuoteFunnelAnswer;
